// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".wrap[data-v-2b5f7882]{width:calc(var(--inner-width)*1px);margin:0 auto;display:flex}.wrap .content[data-v-2b5f7882]{margin-left:20px;width:calc((var(--inner-width) - 280)*1px)}.footer[data-v-2b5f7882]{margin-top:60px;width:100%;opacity:.3}", ""]);
// Exports
module.exports = exports;
